<div class="card">
  <div class="card-header card-header-success p-2">
    <div class="row align-items-center">
      <div class="col">
        <h4 class="card-title">Vobo oportunidad</h4>
      </div>
      <div class="col-2 text-right">
        <button mat-icon-button (click)="onCloseClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <form [formGroup]="formVobo">
      <div class="row">
        <!-- Comentario -->
        <div class="col-md-6 col-sm-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Comentario</mat-label>
            <textarea aria-label="Comentario" matInput formControlName="comentarioCtrl" maxlength="2000" rows="6"
              placeholder="Escribe un comentario" style="background: #cecece45" soloLetraEspacioNumeroAcento></textarea>
          </mat-form-field>
        </div>

        <!-- Radios + Archivos -->
        <div class="col-md-6 col-sm-12">
          <div class="row">
            <div class="col-12">
              <h6 class="mb-0 mt-1">VOBO de cliente:</h6>
              <mat-radio-group formControlName="medioRecepcionCtrl" (change)="onChangeMedioRecepcion()">
                <mat-radio-button [value]="0">
                  <p class="text-black pt-3">Evidencia pendiente</p>
                </mat-radio-button>
                <mat-radio-button [value]="1">
                  <p class="text-black pt-3">Correo</p>
                </mat-radio-button>
                <mat-radio-button [value]="2">
                  <p class="text-black pt-3">Otro</p>
                </mat-radio-button>
              </mat-radio-group>
            </div>

            <!-- Bloque de subir archivos -->
            <div class="col-12">
              <h6 class="mb-0 mt-1">Evidencia VOBO:</h6>
              <div class="row align-items-center">
                <div class="col-12">
                  <div class="card-header card-header-tabs card-header-warning m-0 pt-0 pb-0">
                    <div class="nav-tabs-navigation">
                      <div class="nav-tabs-wrapper">
                        <span class="nav-tabs-title fw-bold h6 m-0">
                          <span>Cargar archivos :</span>
                        </span>
                        <ul class="nav nav-tabs" data-tabs="tabs">
                          <!-- Botón agregar -->
                          <li class="nav-item" style="cursor: pointer">
                            <button class="btn-file nav-link" style="cursor: pointer" type="button" [disabled]="
                                !formVobo.get('medioRecepcionCtrl')?.value ||
                                formVobo.get('medioRecepcionCtrl')?.value === 0
                              ">
                              <a style="cursor: pointer">
                                <i class="material-icons">upload_file</i>
                                Agregar
                              </a>
                              <input aria-label="Agregar" type="file" id="inputFileVobo"
                                accept=".eml,.msg,.pdf,.xls,.xlsx,.xlsm,.doc,.docx,.ppt,.pptx, .msg, .eml" multiple
                                (change)="onCargarVobo($event)" [disabled]="
                                  !formVobo.get('medioRecepcionCtrl')?.value ||
                                  formVobo.get('medioRecepcionCtrl')?.value ===
                                    0
                                " />
                            </button>
                            <div class="ripple-container"></div>
                          </li>

                          <!-- Botón eliminar -->
                          <li class="nav-item" style="cursor: pointer" *ngIf="listaArchivosSelect.length > 0">
                            <button class="nav-link" (click)="onEliminarVobo()" type="button">
                              <a>
                                <i class="material-icons">delete_forever</i>
                                Remover
                              </a>
                            </button>
                            <div class="ripple-container"></div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <!-- Mensaje informativo -->
                  <div *ngIf="
                      !formVobo.get('medioRecepcionCtrl')?.value ||
                      formVobo.get('medioRecepcionCtrl')?.value === 0
                    " class="text-muted mt-1">
                    No se puede cargar evidencia mientras esté seleccionado
                    “Evidencia pendiente” o no se haya elegido un medio.
                  </div>
                </div>
              </div>

              <!-- Lista de archivos -->
              <div class="row mt-2" *ngIf="
                  listaArchivos.length > 0 &&
                  formVobo.get('medioRecepcionCtrl')?.value !== 0
                ">
                <mat-selection-list style="max-height: 230px; overflow: auto" [(ngModel)]="listaArchivosSelect"
                  (ngModelChange)="onChangeFileSelect($event)" [ngModelOptions]="{ standalone: true }">
                  <mat-list-option *ngFor="let item of listaArchivos; index as i" [value]="item" class="text-muted">
                    <p class="text-muted">{{ item.name }}</p>
                  </mat-list-option>
                </mat-selection-list>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- Botones -->
    <div class="row mt-2">
      <div class="col-12 text-center">
        <button class="btn btn-success btn-sm" (click)="guardarVoboClick()" type="submit"
          [disabled]="!(formVobo.valid && validarTipoVobo())">
          <span><i class="material-icons">save</i></span>
          &nbsp; Guardar
        </button>

        <button class="btn btn-info btn-sm" type="button" (click)="onCloseClick()">
          <span><i class="material-icons">cancel</i></span>
          &nbsp; Cancelar
        </button>
      </div>
    </div>
  </div>
</div>